/// <amd-module name="VSSUI/ContextualMenuButton" />
export * from "./Components/ContextualMenuButton/index";
